import { useContext, useEffect, useState } from 'react'
import { useGlobalData } from '@/pages/_app'
import { SiteDataContext } from '@/src/components'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { getMicroCopy } from '@/src/utils/microcopy'

export const useMarketSelector = ({ isOpen, onClose, ref }) => {
  const [marketList, setMarketList] = useState([])
  const { lang } = useContext(SiteDataContext)
  const { markets } = useGlobalData()
  const microCopyData = useMicroCopyData()

  // Outside click handler
  useEffect(() => {
    if (!isOpen) return

    const handleOutSideClick = (event) => {
      if (event.target.closest('.c-header__market-selector')) {
        return
      }

      if (!ref.current?.contains(event.target)) {
        onClose()
      }
    }

    window.addEventListener('mousedown', handleOutSideClick)
    return () => window.removeEventListener('mousedown', handleOutSideClick)
  }, [isOpen, onClose, ref])

  // Market list builder
  useEffect(() => {
    const marketsListItems = []

    markets.forEach((market) => {
      const m = { ...market }
      m.languages = market.locales.map((locale) => {
        const language = locale.split('-')[0]
        return {
          label: getMicroCopy({
            key: `languages.${language}`,
            data: microCopyData[lang]
          }),
          slug: `/${locale}`
        }
      })

      m.title = getMicroCopy({
        key: `market.${m.countryIsoCode.toLowerCase()}`,
        fallback: m.title,
        data: microCopyData[lang]
      })

      marketsListItems.push(m)
    })

    setMarketList([...marketsListItems])
  }, [markets, microCopyData, lang])

  return { marketList }
}
